import { selectors } from './data'

// Localized
export function getText(state) {
    return selectors.localized.getText(state.backendReducer)
}

export function getProcessManagerErrorMessage(state) {
    return selectors.localized.getProcessManagerErrorMessage(state.backendReducer)
}

export function getAttentionText(state) {
    return selectors.localized.getAttentionText(state.backendReducer)
}



// WEBPACK FOOTER //
// ./src/features/Backend/selectors.js